import _merge from 'lodash.merge';
import * as PersistentBarActionTypes from './action-types.constants';
import * as PlayerActionTypes from '../player/action-types.constants';

function getDefaultState() {
    const DEFAULT_STATE = {
        "show": false,
        "height": 0,
        "isIntersecting": true,
        "player": {
            "paused": true,
            "ended": false
        },
        "upNext": {
            "show": true
        }
    }
    return DEFAULT_STATE;
}

const PersistentVideoBar = (state = getDefaultState(), action) => {
    let newState = state;

    const { type } = action;

    switch (type) {
        case PersistentBarActionTypes.UPDATE:
            (() => {
                newState = {
                    "upNext": action.upNext
                }
            })()
            break;
        case PersistentBarActionTypes.READY:
            (() => {
                let show = state.isIntersecting === false;
                newState = {
                    "show": show,
                    "upNext": action.upNext
                }
            })()
            break;
        case PersistentBarActionTypes.INTERSECTION_CHANGE:
            (() => {
                const { isIntersecting } = action;
                const { player, height, upNext } = state;
                let show = isIntersecting === false && player.paused === false;
                if (show === true && player.ended === true && upNext.show === false) {
                    show = false;
                }
                newState = {
                    "isIntersecting": isIntersecting,
                    "show": show,
                    "height": isIntersecting === true ? 0 : height
                }
            })();
            break;
        case PersistentBarActionTypes.ANIMATE:
            newState = {
                "height": action.height
            }
            break;
        case PersistentBarActionTypes.DESTROY:
            (() => {
                newState = getDefaultState();
            })();
            break;
        case PlayerActionTypes.PLAYER_EVENT_MEDIACHANGE:
        case PlayerActionTypes.PLAYER_EVENT_PLAYING:
        case PlayerActionTypes.PLAYER_EVENT_TIMEUPDATE:
            (() => {
                // Prevent Time Updates from updating the state
                if (state.player.paused === true || state.player.ended === true) {
                    let show = state.isIntersecting === false;
                    newState = {
                        "show": show,
                        "player": {
                            "paused": false,
                            "ended": false
                        }
                    }
                }

            })()

            break;
        case PlayerActionTypes.PLAYER_EVENT_PAUSED:
            newState = {
                "show": false,
                "player": {
                    "paused": true
                }
            }
            break;
        case PlayerActionTypes.PLAYER_EVENT_ENDED:
            (() => {
                let { show, upNext } = state;
                if (show === true && upNext.show === false) {
                    show = false;
                }
                newState = {
                    "show": show,
                    "player": {
                        "ended": true
                    }
                }
            })();
            break;
        default:
            newState = state
    }

    if (newState !== state) {
        newState = _merge(getDefaultState(), state, newState);
        //console.log("[PersistentVideoBar Reducers] Action Type: ", type)
        //console.log("[PersistentVideoBar Reducers] New State: ", newState)
    }
    return newState;
}

export default PersistentVideoBar;